import {getFocusableSelector} from "./get-focusable-selector";
import {getPlayerParams} from "./get-player-params";

export function popups() {
  let doc = $(document);
  let body = $('body');
  let openClass = 'open';
  let closeClass = 'close';
  let popupClassListAttr = 'data-classlist';
  let popupCloseClassName = 'popup-close';
  let popupCloseTemplate = '<a href="#" role="button" class="' + popupCloseClassName + ' icon-cross" aria-label="close popup"><i></i></a>';
  let videoPopupPrefix = 'video-popup';
  let videoPopupContentName = videoPopupPrefix + '-content';
  let videoPopupInnerName = videoPopupPrefix + '-inner';
  let hiddenAttr = 'aria-hidden';
  let tabindexAttr = 'tabindex';
  let focusableObjects = [];
  let focusableSelector = getFocusableSelector();

  function addFocusable($objects) {
    $objects.each(function () {
      let $object = $(this);
      let tabindex = $object.attr(tabindexAttr);

      focusableObjects.push({
        $item: $object,
        tabindex: tabindex === undefined ? null : tabindex
      });

      $object.attr(tabindexAttr, -1);
    });
  }

  function removeFocusable() {
    focusableObjects.forEach(function (item) {
      if (item.tabindex === null) {
        item.$item.removeAttr(tabindexAttr);
      } else {
        item.$item.attr(tabindexAttr, item.tabindex);
      }
    });

    focusableObjects = [];
  }

  function toggleTabindex($popupSiblings) {
    if ($popupSiblings === undefined) { // remove tabindex
      removeFocusable();

    } else { //add tabindex

      $popupSiblings.each(function () {
        let $item = $(this);

        addFocusable($item.add($item.find(focusableSelector)));
      });
    }
  }

  function hidePopups(event, popupInnerName, closePopupMethod) {
    let curPopup = $(this);
    let target = $(event.target);
    let isCloseBtn = Boolean(target.is('.' + popupCloseClassName) || target.closest('.' + popupCloseClassName).length);

    if (isCloseBtn) {
      event.preventDefault();
      closePopupMethod(curPopup);
    } else {

      let isPopupInner = Boolean(target.is('.' + popupInnerName) || target.closest('.' + popupInnerName).length);

      if (!isPopupInner) {
        closePopupMethod(curPopup);
      }
    }
  }

  function popup() {
    let
      popupCloseEventNameSpace = 'closePopup',
      popupInnerClassName = 'popup-inner',
      isPopupOpen = false,
      closePopup = function (popup) {
        let video = popup.find('video');
        let playerVidyardAPI = window.VidyardV4;

        if (video.length) {
          video[0].pause();
        }

        if(playerVidyardAPI !== undefined){
          let playerVidyard = popup.find('[uuid]');

          if(playerVidyard.length){
            let playerVidyardID = playerVidyard.attr('uuid');

            playerVidyard = playerVidyardAPI.api.getPlayersByUUID(playerVidyardID);
            playerVidyard[0].pause();
          }
        }

        doc.off('keydown.' + popupCloseEventNameSpace);
        popup.addClass(closeClass)
          .siblings().removeAttr(hiddenAttr);

        toggleTabindex();

        setTimeout(function () {
          popup
            .removeClass(openClass + ' ' + closeClass)
            .attr(hiddenAttr, true);
          isPopupOpen = false;
        }, 550);
      },
      /*initScrollbarVertical = function (popupInner) {
        if (popupInner.length) {,
          if (!api.isMobileDevice()) {
            OverlayScrollbars(popupInner, {});
          }
        }
      },*/
      _create = function (popupID) {
        let content = $('.popup-content[data-popup-id=' + popupID + ']').eq(0).addClass('init');
        let classList = content.attr(popupClassListAttr);
        let popupClassList = '';

        if (classList) {
          popupClassList = classList;
          content.removeAttr(popupClassListAttr);
        }

        let tpl = $('<div class="popup ' + popupClassList + '" data-popup-id="' + popupID + '" role="dialog" aria-modal="true" aria-label="popup" ' + hiddenAttr + '="true" ><div class="' + popupInnerClassName + '">' + popupCloseTemplate + '</div></div>');

        tpl.find('.' + popupInnerClassName).append(content);
        body.append(tpl);
      };

    body.on('click.openPopup', '.open-popup', function (e) {
      let _this = this;

      e.preventDefault();

      if (!isPopupOpen) {
        isPopupOpen = true;

        let
          curPopupID = _this.getAttribute('data-popup-id'),
          curPopup = $('.popup[data-popup-id=' + curPopupID + ']'),
          isHasPopup = Boolean(curPopup.length);

        if (!isHasPopup) {
          _create(curPopupID);
        }

        requestAnimationFrame(function () {
          if (!isHasPopup) {
            curPopup = $('.popup[data-popup-id=' + curPopupID + ']');
          }

          curPopup
            .attr(hiddenAttr, false)
            .addClass(openClass);

          let curPopupSiblings = curPopup.siblings().attr(hiddenAttr, true);
          toggleTabindex(curPopupSiblings);

          curPopup.find('.' + popupCloseClassName).focus();
          doc.on('keydown.' + popupCloseEventNameSpace, function (ev) {
            // ESCAPE key pressed
            if (ev.keyCode == 27) {
              closePopup(curPopup);
            }
          });
        });
      }
    }).on('click.' + popupCloseEventNameSpace, '.popup', function (e) {
      hidePopups.call(this, e, popupInnerClassName, closePopup);
    });
  }

  function videoPopup() {
    let isPopupOpen = false;
    let closePopup = function (popup) {
      doc.off('keydown.closeVideoPopup');
      popup
        .addClass(closeClass)
        .siblings().removeAttr(hiddenAttr);

      toggleTabindex();

      setTimeout(function () {
        if (popup.length) {
          popup.remove();
          isPopupOpen = false;
        }
      }, 550);
    };

    body.on('click', '.open-' + videoPopupPrefix, function (e) {
      let _this = this;

      e.preventDefault();

      if (!isPopupOpen) {
        isPopupOpen = true;

        let options = getPlayerParams($(_this).attr('data-src-video'));

        /* let srcDefaults = 'autoplay=1';//&mute=1
         let curSrc = $(_this).attr('data-src-video');
         let isMp4VideoSrc = curSrc.indexOf(".mp4") > -1;
         let src = curSrc;

         if (!isMp4VideoSrc) {
           src = src + (src.indexOf("?") > -1 ? '&' : '?') + srcDefaults;
         }*/

        let playerTemplate = options.template;
        let popup = $('<div class="' + videoPopupPrefix + '" role="dialog" aria-modal="true" aria-label="video popup">' + popupCloseTemplate + '<div class="' + videoPopupInnerName + '"><div class="' + videoPopupContentName + '"><div class="' + videoPopupPrefix + '-iframe"><img role="presentation" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==">' + playerTemplate + '</div></div></div></div>');

        body.append(popup);

        requestAnimationFrame(function () {
          popup.addClass(openClass);

          let popupSiblings = popup.siblings().attr(hiddenAttr, true);
          toggleTabindex(popupSiblings);

          popup.find('.' + popupCloseClassName).focus();
          //popup.find('iframe')[0].contentWindow.postMessage(JSON.stringify(commandPlay), "*");
          doc.on('keydown.closeVideoPopup', function (ev) {
            // ESCAPE key pressed
            if (ev.keyCode == 27) {
              closePopup(popup);
            }
          });
        });
      }
    }).on('click', '.' + videoPopupPrefix, function (e) {
      hidePopups.call(this, e, videoPopupInnerName, closePopup);
    });
  }

  $(document).ready(function () {
    popup();
    videoPopup();
  });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js